<template>
  <v-content>
    <v-container fluid pa-3>
      <v-layout style="max-height: calc(100vh - 130px);">
        <v-flex xs12 style="overflow-y: auto;">
          <v-layout wrap>
            <v-flex xs12 lg6>
              <Panel title="Shipments">
                <div style="margin-left: auto; margin-right: auto; height: calc(100vh - 520px); width: 100%; min-height: 160px;">
                  <div style="margin-left: auto; margin-right: auto; height: min(calc(100vh - 520px), 40vw); width: min(calc(100vh - 520px), 40vw); min-height: 160px;">
                    <a-chart type="donut" height="100%" width="100%" :options="shipmentOptions" :series="shipmentSeries"></a-chart>
                  </div>
                </div>
              </Panel>
            </v-flex>
            <v-flex xs12 lg6>
              <Panel title="Pallets">
                <div style="margin-left: auto; margin-right: auto; height: calc(100vh - 520px); width: 100%; min-height: 160px;">
                  <div style="margin-left: auto; margin-right: auto; height: min(calc(100vh - 520px), 40vw); width: min(calc(100vh - 520px), 40vw); min-height: 160px;">
                    <a-chart type="donut" height="100%" width="100%" :options="palletOptions" :series="palletSeries"></a-chart>
                  </div>
                </div>
              </Panel>
            </v-flex>
            <v-flex xs12 lg6>
              <Panel title="Log" link-right="Log" class="dashboardLogs">
                <div style="height: 190px; width: 100%;" v-if="logs.length === 0">
                  No updates at the moment
                </div>
                <div style="height: 190px; width: 100%; overflow-y: auto;" v-if="logs.length > 0">
                  <table class="logs">
                    <tr v-for="log in logs" v-bind:key="log.id">
                      <td style="width: 60px; white-space: nowrap;">{{ shortDatetime(log.clientTimestamp) }}</td>
                      <td>{{ log.message }}</td>
                    </tr>
                  </table>
                </div>
              </Panel>
            </v-flex>
            <v-flex xs12 lg6>
              <Panel title="Warnings" class="dashboardWarnings">
                <div style="height: 190px;" v-if="warnings.length === 0">
                  No warnings at the moment
                </div>
                <div style="height: 190px; width: 100%; overflow-y: auto;" v-if="warnings.length > 0">
                  <div v-for="warning in warnings" v-bind:key="warning.shipmentNumber" :class="'warn warn_' + warning.severity">
                    <table>
                      <tr>
                        <td style="padding: 0;">
                          <div class="warnIcon"><v-icon>warning</v-icon></div>
                        </td>
                        <td style="padding: 0;">
                          <div class="warnMessage">{{ warning.message }}</div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </Panel>
            </v-flex>
            <v-flex xs12 pa-3 v-if="false">
              Refreshed on {{ refreshedDateFormatted }}
            </v-flex>
            <v-flex xs12 pa-3 v-if="false">
              {{ updatedMessage }}
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import axios from 'axios'
import Panel from '../components/Panel'
import AChart from 'vue-apexcharts'
import DateUtil from '@/assets/javascript/dateutil'

export default {
  name: 'Dashboard',
  components: { Panel, AChart },
  data () {
    return {
      updatedMessage: 'The system has been updated on July 12, 2019',
      refreshedDate: new Date(),
      refreshInterval: null,
      dashboard: null,
      shipmentSeries: [],
      palletSeries: [],
      logs: [],
      warnings: [],
      shipmentOptions: {
        labels: ['Production', 'Delivered'],
        colors: ['#008D80', '#404088'],
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                total: {
                  show: true
                }
              }
            }
          }
        },
        tooltip: {
          enabled: false
        },
        states: {
          hover: {
            filter: {
              type: 'none'
            }
          }
        },
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center'
        }
      },
      palletOptions: {
        labels: ['Planned', 'In production', 'Produced', 'Ready', 'In transport', 'Repacked', 'Delivered'],
        colors: ['#DDDDDD', '#AAEECC', '#008D80', '#CCCCFF', '#8080DD', '#303030', '#404088'],
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                total: {
                  show: true
                }
              }
            }
          }
        },
        tooltip: {
          enabled: false
        },
        states: {
          hover: {
            filter: {
              type: 'none'
            }
          }
        },
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center'
        }
      }
    }
  },
  created: function () {
    this.refreshDashboard()
    let refreshMethod = this.refreshDashboard
    this.$store.dispatch('page/setSidebarItem', { key: 'dashboard' })
    this.refreshInterval = setInterval(function () {
      refreshMethod()
    }, 60000)
  },
  beforeDestroy: function () {
    clearInterval(this.refreshInterval)
  },
  methods: {
    refreshDashboard () {
      // console.log('Refreshing dashboard')
      axios.get('/backend/rest/dashboard')
        .then(response => {
          // console.log('Dashboard: ' + JSON.stringify(response.data))
          this.dashboard = response.data

          this.refreshedDate = new Date()

          this.shipmentSeries = []
          let shipmentCount = this.dashboard.shipments.count
          let shipmentProduction = 0
          shipmentProduction += shipmentCount.DRAFT ? shipmentCount.DRAFT : 0
          shipmentProduction += shipmentCount.PLANNED ? shipmentCount.PLANNED : 0
          shipmentProduction += shipmentCount.IN_PRODUCTION ? shipmentCount.IN_PRODUCTION : 0
          shipmentProduction += shipmentCount.READY_FOR_PICKUP ? shipmentCount.READY_FOR_PICKUP : 0
          this.shipmentSeries.push(shipmentProduction)
          this.shipmentSeries.push(shipmentCount.DELIVERED ? shipmentCount.DELIVERED : 0)

          this.palletSeries = []
          let palletCount = this.dashboard.pallets.count
          this.palletSeries.push(palletCount.PLANNED ? palletCount.PLANNED : 0)
          this.palletSeries.push(palletCount.IN_PRODUCTION ? palletCount.IN_PRODUCTION : 0)
          this.palletSeries.push(palletCount.PRODUCED ? palletCount.PRODUCED : 0)
          this.palletSeries.push(palletCount.READY_FOR_PICKUP ? palletCount.READY_FOR_PICKUP : 0)
          this.palletSeries.push(palletCount.IN_TRANSPORT ? palletCount.IN_TRANSPORT : 0)
          this.palletSeries.push(palletCount.REPACKED ? palletCount.REPACKED : 0)
          this.palletSeries.push(palletCount.DELIVERED ? palletCount.DELIVERED : 0)

          this.logs = this.dashboard.logs
          this.warnings = this.dashboard.warnings
        })
    },
    shortDatetime (date) {
      return DateUtil.extraShortDatetime(date)
    }
  },
  computed: {
    refreshedDateFormatted: function () {
      return ((this.refreshedDate.getHours() < 10 ? '0' : '') + this.refreshedDate.getHours()) + ':' + ((this.refreshedDate.getMinutes() < 10 ? '0' : '') + this.refreshedDate.getMinutes()) + ':' + ((this.refreshedDate.getSeconds() < 10 ? '0' : '') + this.refreshedDate.getSeconds())
    }
  }
}
</script>

<style scoped>
  h1 {
    font-size: 16px;
    color: #004d40;
    border-bottom: 1px solid #004d40;
  }
  table.logs {
    width: 100%;
  }
  table.logs tr td {
    font-size: 12px;
    line-height: 16px;
    vertical-align: top;
  }
  .warn {
    width: 100%;
    font-size: 12px;
    border: 1px solid #DDDDDD;
    padding: 1px;
    border-radius: 3px;
    margin-bottom: 3px;
    vertical-align: top;
  }
  .warnIcon {
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    padding-left: 5px;
  }
  .warnMessage {
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    padding-left: 10px;
  }
  .warn_CRITICAL .v-icon {
    color: #DD0000;
  }
  .warn_HIGH .v-icon {
    color: #DD8800;
  }
  .warn_LOW .v-icon {
    color: #DDDD00;
  }
  .element::-webkit-scrollbar {
    width: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue